import React, { useState, useRef } from 'react';
import { Layout } from '../components/Layout/Layout';
import { CalendarIcon, DollarSignIcon, CheckCircleIcon, ClockIcon, ArrowUpIcon, ArrowDownIcon, FilterIcon, DownloadIcon, FileTextIcon, AlertCircleIcon, PlusIcon, ChevronDownIcon, ChevronUpIcon, SearchIcon } from 'lucide-react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { PaymentDetailsModal } from '../components/Payments/PaymentDetailsModal';
import { motion, AnimatePresence } from 'framer-motion';
export const RepaymentPage = () => {
  const [viewMode, setViewMode] = useState<'list' | 'calendar'>('list');
  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState<any>(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const calendarRef = useRef<any>(null);
  // Sample project data with payment information
  const projects = [{
    id: 1,
    title: 'Sustainable Rice Farming Initiative',
    location: 'MADA Region, Kedah',
    totalAmount: 'RM 320,000',
    remainingAmount: 'RM 96,000',
    completionDate: '2024-03-15',
    status: 'Ongoing',
    progress: 70,
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80',
    payments: [{
      id: 101,
      amount: 'RM 96,000',
      date: '2023-06-15',
      status: 'Paid',
      description: 'Initial investment disbursement',
      reference: 'TRX-23061501',
      paymentMethod: 'Bank Transfer',
      account: 'CIMB Bank - 8010254789'
    }, {
      id: 102,
      amount: 'RM 64,000',
      date: '2023-09-15',
      status: 'Paid',
      description: 'Milestone 1: Land preparation complete',
      reference: 'TRX-23091502',
      paymentMethod: 'Bank Transfer',
      account: 'CIMB Bank - 8010254789'
    }, {
      id: 103,
      amount: 'RM 64,000',
      date: '2023-12-15',
      status: 'Paid',
      description: 'Milestone 2: Planting complete',
      reference: 'TRX-23121503',
      paymentMethod: 'Bank Transfer',
      account: 'CIMB Bank - 8010254789'
    }, {
      id: 104,
      amount: 'RM 96,000',
      date: '2024-03-15',
      status: 'Scheduled',
      description: 'Final payment upon harvest',
      reference: 'TRX-24031504',
      paymentMethod: 'Bank Transfer',
      account: 'CIMB Bank - 8010254789'
    }]
  }, {
    id: 2,
    title: 'Vertical Farming Technology',
    location: 'Cyberjaya, Selangor',
    totalAmount: 'RM 550,000',
    remainingAmount: 'RM 275,000',
    completionDate: '2024-12-01',
    status: 'Ongoing',
    progress: 50,
    image: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    payments: [{
      id: 201,
      amount: 'RM 137,500',
      date: '2023-06-01',
      status: 'Paid',
      description: 'Initial investment disbursement',
      reference: 'TRX-23060101',
      paymentMethod: 'Bank Transfer',
      account: 'Maybank - 1573928465'
    }, {
      id: 202,
      amount: 'RM 137,500',
      date: '2023-12-01',
      status: 'Paid',
      description: 'Milestone 1: Infrastructure setup complete',
      reference: 'TRX-23120102',
      paymentMethod: 'Bank Transfer',
      account: 'Maybank - 1573928465'
    }, {
      id: 203,
      amount: 'RM 137,500',
      date: '2024-06-01',
      status: 'Scheduled',
      description: 'Milestone 2: Growing system operational',
      reference: 'TRX-24060103',
      paymentMethod: 'Bank Transfer',
      account: 'Maybank - 1573928465'
    }, {
      id: 204,
      amount: 'RM 137,500',
      date: '2024-12-01',
      status: 'Scheduled',
      description: 'Final payment upon project completion',
      reference: 'TRX-24120104',
      paymentMethod: 'Bank Transfer',
      account: 'Maybank - 1573928465'
    }]
  }, {
    id: 3,
    title: 'Organic Musang King Durian Farm',
    location: 'Raub, Pahang',
    totalAmount: 'RM 490,000',
    remainingAmount: 'RM 0',
    completionDate: '2023-08-20',
    status: 'Completed',
    progress: 100,
    image: 'https://images.unsplash.com/photo-1622579521530-42bae5f80321?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    payments: [{
      id: 301,
      amount: 'RM 147,000',
      date: '2020-08-20',
      status: 'Paid',
      description: 'Initial investment disbursement',
      reference: 'TRX-20082001',
      paymentMethod: 'Bank Transfer',
      account: 'RHB Bank - 2634109875'
    }, {
      id: 302,
      amount: 'RM 98,000',
      date: '2021-08-20',
      status: 'Paid',
      description: 'Year 1 milestone: Plantation established',
      reference: 'TRX-21082002',
      paymentMethod: 'Bank Transfer',
      account: 'RHB Bank - 2634109875'
    }, {
      id: 303,
      amount: 'RM 98,000',
      date: '2022-08-20',
      status: 'Paid',
      description: 'Year 2 milestone: Trees maturing',
      reference: 'TRX-22082003',
      paymentMethod: 'Bank Transfer',
      account: 'RHB Bank - 2634109875'
    }, {
      id: 304,
      amount: 'RM 147,000',
      date: '2023-08-20',
      status: 'Paid',
      description: 'Final payment: First harvest complete',
      reference: 'TRX-23082004',
      paymentMethod: 'Bank Transfer',
      account: 'RHB Bank - 2634109875'
    }]
  }, {
    id: 4,
    title: 'Aquaculture Farming System',
    location: 'Kuala Selangor, Selangor',
    totalAmount: 'RM 420,000',
    remainingAmount: 'RM 210,000',
    completionDate: '2025-01-15',
    status: 'Ongoing',
    progress: 45,
    image: 'https://images.unsplash.com/photo-1535090467336-9501f96eef89?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1473&q=80',
    payments: [{
      id: 401,
      amount: 'RM 105,000',
      date: '2023-01-15',
      status: 'Paid',
      description: 'Initial investment disbursement',
      reference: 'TRX-23011501',
      paymentMethod: 'Bank Transfer',
      account: 'Public Bank - 3045678912'
    }, {
      id: 402,
      amount: 'RM 105,000',
      date: '2023-07-15',
      status: 'Paid',
      description: 'Milestone 1: Pond construction complete',
      reference: 'TRX-23071502',
      paymentMethod: 'Bank Transfer',
      account: 'Public Bank - 3045678912'
    }, {
      id: 403,
      amount: 'RM 105,000',
      date: '2024-01-15',
      status: 'Scheduled',
      description: 'Milestone 2: First stocking complete',
      reference: 'TRX-24011503',
      paymentMethod: 'Bank Transfer',
      account: 'Public Bank - 3045678912'
    }, {
      id: 404,
      amount: 'RM 105,000',
      date: '2025-01-15',
      status: 'Scheduled',
      description: 'Final payment upon first harvest',
      reference: 'TRX-25011504',
      paymentMethod: 'Bank Transfer',
      account: 'Public Bank - 3045678912'
    }]
  }];
  // Prepare calendar events from payment data
  const getCalendarEvents = () => {
    const events: any[] = [];
    projects.forEach(project => {
      project.payments.forEach(payment => {
        const backgroundColor = payment.status === 'Paid' ? '#4CAF50' : payment.status === 'Scheduled' ? '#2196F3' : payment.status === 'Delayed' ? '#FFC107' : payment.status === 'Failed' ? '#F44336' : '#9E9E9E';
        events.push({
          id: `payment-${payment.id}`,
          title: `${project.title}: ${payment.amount}`,
          start: payment.date,
          backgroundColor,
          borderColor: backgroundColor,
          extendedProps: {
            projectId: project.id,
            payment: payment,
            project: project
          }
        });
      });
    });
    return events;
  };
  // Handle calendar event click
  const handleEventClick = (info: any) => {
    const {
      projectId,
      payment,
      project
    } = info.event.extendedProps;
    setSelectedProject(projectId);
    setSelectedPayment({
      ...payment,
      projectTitle: project.title
    });
    setShowPaymentDetails(true);
  };
  // Filter projects based on status
  const filteredProjects = projects.filter(project => {
    if (statusFilter === 'all') return true;
    return project.status.toLowerCase() === statusFilter.toLowerCase();
  });
  // Handle payment row click
  const handlePaymentClick = (project: any, payment: any) => {
    setSelectedPayment({
      ...payment,
      projectTitle: project.title
    });
    setShowPaymentDetails(true);
  };
  // Calculate payment statistics
  const totalPaidAmount = projects.reduce((sum, project) => {
    const paidPayments = project.payments.filter(p => p.status === 'Paid');
    const paidAmount = paidPayments.reduce((pSum, payment) => {
      return pSum + parseInt(payment.amount.replace(/\D/g, ''));
    }, 0);
    return sum + paidAmount;
  }, 0);
  const totalScheduledAmount = projects.reduce((sum, project) => {
    const scheduledPayments = project.payments.filter(p => p.status === 'Scheduled');
    const scheduledAmount = scheduledPayments.reduce((pSum, payment) => {
      return pSum + parseInt(payment.amount.replace(/\D/g, ''));
    }, 0);
    return sum + scheduledAmount;
  }, 0);
  const upcomingPayments = projects.flatMap(project => project.payments.filter(p => p.status === 'Scheduled').map(payment => ({
    ...payment,
    projectTitle: project.title
  }))).sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  const nextPayment = upcomingPayments.length > 0 ? upcomingPayments[0] : null;
  return <Layout data-id="element-1476">
      <div className="container mx-auto px-4 py-8" data-id="element-1477">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8" data-id="element-1478">
          <div data-id="element-1479">
            <h1 className="text-3xl font-bold text-soil-brown" data-id="element-1480">
              Repayment Module
            </h1>
            <p className="text-gray-600 mt-1" data-id="element-1481">
              Track and manage project repayments and disbursements
            </p>
          </div>
          <div className="mt-4 md:mt-0 flex space-x-2" data-id="element-1482">
            <button className="btn btn-outline flex items-center" data-id="element-1483">
              <DownloadIcon size={18} className="mr-2" data-id="element-1484" />
              Export
            </button>
            <button className="btn btn-primary flex items-center" data-id="element-1485">
              <PlusIcon size={18} className="mr-2" data-id="element-1486" />
              Add Payment
            </button>
          </div>
        </div>
        {/* Payment Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-1487">
          <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-leaf-green" data-id="element-1488">
            <p className="text-gray-500 text-sm" data-id="element-1489">Total Disbursed</p>
            <h3 className="text-2xl font-bold mt-1" data-id="element-1490">
              RM {(totalPaidAmount / 1000).toFixed(0)},000
            </h3>
            <div className="flex items-center mt-2 text-green-600 text-sm" data-id="element-1491">
              <ArrowUpIcon size={14} className="mr-1" data-id="element-1492" />
              <span data-id="element-1493">From {projects.length} projects</span>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-blue-500" data-id="element-1494">
            <p className="text-gray-500 text-sm" data-id="element-1495">Remaining Disbursements</p>
            <h3 className="text-2xl font-bold mt-1" data-id="element-1496">
              RM {(totalScheduledAmount / 1000).toFixed(0)},000
            </h3>
            <div className="flex items-center mt-2 text-blue-600 text-sm" data-id="element-1497">
              <ClockIcon size={14} className="mr-1" data-id="element-1498" />
              <span data-id="element-1499">{upcomingPayments.length} scheduled payments</span>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-amber-500" data-id="element-1500">
            <p className="text-gray-500 text-sm" data-id="element-1501">Next Payment</p>
            {nextPayment ? <>
                <h3 className="text-2xl font-bold mt-1" data-id="element-1502">
                  {nextPayment.amount}
                </h3>
                <div className="flex items-center mt-2 text-amber-600 text-sm" data-id="element-1503">
                  <CalendarIcon size={14} className="mr-1" data-id="element-1504" />
                  <span data-id="element-1505">
                    Due on{' '}
                    {new Date(nextPayment.date).toLocaleDateString('en-MY', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                })}
                  </span>
                </div>
              </> : <>
                <h3 className="text-2xl font-bold mt-1" data-id="element-1506">RM 0</h3>
                <div className="flex items-center mt-2 text-gray-600 text-sm" data-id="element-1507">
                  <CheckCircleIcon size={14} className="mr-1" data-id="element-1508" />
                  <span data-id="element-1509">No upcoming payments</span>
                </div>
              </>}
          </div>
          <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-purple-500" data-id="element-1510">
            <p className="text-gray-500 text-sm" data-id="element-1511">Active Projects</p>
            <h3 className="text-2xl font-bold mt-1" data-id="element-1512">
              {projects.filter(p => p.status !== 'Completed').length}
            </h3>
            <div className="flex items-center mt-2 text-purple-600 text-sm" data-id="element-1513">
              <ArrowUpIcon size={14} className="mr-1" data-id="element-1514" />
              <span data-id="element-1515">
                {projects.filter(p => p.status === 'Completed').length}{' '}
                completed projects
              </span>
            </div>
          </div>
        </div>
        {/* View Toggle and Filters */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6" data-id="element-1516">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-1517">
            <div className="flex-1 relative" data-id="element-1518">
              <SearchIcon size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1519" />
              <input type="text" placeholder="Search projects or payments..." className="input-field pl-10 w-full" data-id="element-1520" />
            </div>
            <div className="flex space-x-2" data-id="element-1521">
              <button className={`btn ${filterOpen ? 'btn-primary' : 'btn-outline'} flex items-center`} onClick={() => setFilterOpen(!filterOpen)} data-id="element-1522">
                <FilterIcon size={18} className="mr-2" data-id="element-1523" />
                Filter
              </button>
              <div className="flex border rounded-lg overflow-hidden" data-id="element-1524">
                <button className={`p-2 ${viewMode === 'list' ? 'bg-leaf-green text-white' : 'bg-gray-100'}`} onClick={() => setViewMode('list')} aria-label="List view" data-id="element-1525">
                  <FileTextIcon size={18} data-id="element-1526" />
                </button>
                <button className={`p-2 ${viewMode === 'calendar' ? 'bg-leaf-green text-white' : 'bg-gray-100'}`} onClick={() => setViewMode('calendar')} aria-label="Calendar view" data-id="element-1527">
                  <CalendarIcon size={18} data-id="element-1528" />
                </button>
              </div>
            </div>
          </div>
          <AnimatePresence data-id="element-1529">
            {filterOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} className="overflow-hidden" data-id="element-1530">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 pt-4 border-t" data-id="element-1531">
                  <div data-id="element-1532">
                    <label className="block text-gray-700 font-medium mb-2" data-id="element-1533">
                      Project Status
                    </label>
                    <select className="input-field" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-1534">
                      <option value="all" data-id="element-1535">All Statuses</option>
                      <option value="ongoing" data-id="element-1536">Ongoing</option>
                      <option value="completed" data-id="element-1537">Completed</option>
                    </select>
                  </div>
                  <div data-id="element-1538">
                    <label className="block text-gray-700 font-medium mb-2" data-id="element-1539">
                      Payment Status
                    </label>
                    <select className="input-field" data-id="element-1540">
                      <option value="all" data-id="element-1541">All Payments</option>
                      <option value="paid" data-id="element-1542">Paid</option>
                      <option value="scheduled" data-id="element-1543">Scheduled</option>
                      <option value="delayed" data-id="element-1544">Delayed</option>
                    </select>
                  </div>
                  <div data-id="element-1545">
                    <label className="block text-gray-700 font-medium mb-2" data-id="element-1546">
                      Date Range
                    </label>
                    <select className="input-field" data-id="element-1547">
                      <option value="all" data-id="element-1548">All Time</option>
                      <option value="past30" data-id="element-1549">Past 30 Days</option>
                      <option value="past90" data-id="element-1550">Past 90 Days</option>
                      <option value="next30" data-id="element-1551">Next 30 Days</option>
                      <option value="next90" data-id="element-1552">Next 90 Days</option>
                      <option value="custom" data-id="element-1553">Custom Range</option>
                    </select>
                  </div>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
        {/* Calendar View */}
        {viewMode === 'calendar' && <div className="bg-white rounded-lg shadow-sm p-4 mb-6" data-id="element-1554">
            <div style={{
          height: '650px'
        }} data-id="element-1555">
              <FullCalendar ref={calendarRef} plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]} initialView="dayGridMonth" events={getCalendarEvents()} headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek'
          }} eventClick={handleEventClick} height="100%" eventTimeFormat={{
            hour: 'numeric',
            minute: '2-digit',
            meridiem: 'short'
          }} data-id="element-1556" />
            </div>
          </div>}
        {/* List View */}
        {viewMode === 'list' && <div className="space-y-6" data-id="element-1557">
            {filteredProjects.map(project => <div key={project.id} className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-1558">
                <div className="flex flex-col sm:flex-row" data-id="element-1559">
                  <div className="sm:w-1/4 md:w-1/5 h-32 sm:h-auto" data-id="element-1560">
                    <img src={project.image} alt={project.title} className="w-full h-full object-cover" data-id="element-1561" />
                  </div>
                  <div className="flex-1 p-4" data-id="element-1562">
                    <div className="flex flex-col sm:flex-row justify-between" data-id="element-1563">
                      <div data-id="element-1564">
                        <h3 className="text-xl font-semibold" data-id="element-1565">
                          {project.title}
                        </h3>
                        <p className="text-gray-600 text-sm" data-id="element-1566">
                          {project.location}
                        </p>
                      </div>
                      <div className="mt-2 sm:mt-0 flex items-center" data-id="element-1567">
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${project.status === 'Completed' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-1568">
                          {project.status}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4" data-id="element-1569">
                      <div data-id="element-1570">
                        <p className="text-xs text-gray-500" data-id="element-1571">
                          Total Investment
                        </p>
                        <p className="font-semibold" data-id="element-1572">{project.totalAmount}</p>
                      </div>
                      <div data-id="element-1573">
                        <p className="text-xs text-gray-500" data-id="element-1574">
                          Remaining Disbursement
                        </p>
                        <p className="font-semibold" data-id="element-1575">
                          {project.remainingAmount}
                        </p>
                      </div>
                      <div data-id="element-1576">
                        <p className="text-xs text-gray-500" data-id="element-1577">Completion Date</p>
                        <p className="font-semibold" data-id="element-1578">
                          {new Date(project.completionDate).toLocaleDateString('en-MY', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric'
                    })}
                        </p>
                      </div>
                    </div>
                    <div className="mt-4" data-id="element-1579">
                      <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1580">
                        <div className="bg-leaf-green h-2 rounded-full" style={{
                    width: `${project.progress}%`
                  }} data-id="element-1581"></div>
                      </div>
                      <p className="text-sm text-gray-600 mt-1" data-id="element-1582">
                        {project.progress}% Complete
                      </p>
                    </div>
                  </div>
                </div>
                <div className="border-t" data-id="element-1583">
                  <div className="p-4" data-id="element-1584">
                    <h4 className="font-medium mb-3" data-id="element-1585">Payment Schedule</h4>
                    <div className="overflow-x-auto" data-id="element-1586">
                      <table className="min-w-full divide-y divide-gray-200" data-id="element-1587">
                        <thead data-id="element-1588">
                          <tr data-id="element-1589">
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1590">
                              Date
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1591">
                              Amount
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1592">
                              Description
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1593">
                              Reference
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1594">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200" data-id="element-1595">
                          {project.payments.map(payment => <tr key={payment.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handlePaymentClick(project, payment)} data-id="element-1596">
                              <td className="px-3 py-3 whitespace-nowrap text-sm" data-id="element-1597">
                                {new Date(payment.date).toLocaleDateString('en-MY', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                              </td>
                              <td className="px-3 py-3 whitespace-nowrap text-sm font-medium" data-id="element-1598">
                                {payment.amount}
                              </td>
                              <td className="px-3 py-3 text-sm" data-id="element-1599">
                                {payment.description}
                              </td>
                              <td className="px-3 py-3 whitespace-nowrap text-sm" data-id="element-1600">
                                {payment.reference}
                              </td>
                              <td className="px-3 py-3 whitespace-nowrap" data-id="element-1601">
                                <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${payment.status === 'Paid' ? 'bg-green-100 text-green-800' : payment.status === 'Scheduled' ? 'bg-blue-100 text-blue-800' : payment.status === 'Delayed' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-1602">
                                  {payment.status}
                                </span>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>}
      </div>
      {/* Payment Details Modal */}
      {showPaymentDetails && selectedPayment && <PaymentDetailsModal payment={selectedPayment} onClose={() => setShowPaymentDetails(false)} data-id="element-1603" />}
    </Layout>;
};